import { usePermissionsContext } from '../contexts/PermissionsContext';
import { AppPermission, AppRole } from '../types';

export function usePermissions() {
  const context = usePermissionsContext();

  return {
    hasPermission: context.hasPermission,
    hasRole: context.hasRole,
    hasAnyPermission: context.hasAnyPermission,
    hasAllPermissions: context.hasAllPermissions,
    userRole: context.role,
    permissions: context.permissions,
    isLoading: context.isLoading,

    // Helpers granulares para proteção rápida de campos e botões
    canViewOrderPrices: () => context.hasPermission('view_order_prices'),
    canEditOrderPrices: () => context.hasPermission('edit_order_prices'),
    canViewOrderRepasse: () => context.hasPermission('view_order_repasse'),
    canEditOrderRepasse: () => context.hasPermission('edit_order_repasse'),
    canViewOrderMargin: () => context.hasPermission('view_order_margin'),
    canViewPeopleDocs: () => context.hasPermission('view_people_docs'),
    canViewPeopleBank: () => context.hasPermission('view_people_bank'),
    canViewFinancialValues: () => context.hasPermission('view_financial_values'),
    canViewFiscal: () => context.hasPermission('view_fiscal'),
    canEmitCte: () => context.hasPermission('emit_cte'),
    canEmitNfse: () => context.hasPermission('emit_nfse'),
    canCancelFiscal: () => context.hasPermission('cancel_fiscal'),
    canEdit: (entity?: 'orders' | 'financial' | 'vehicles' | 'people' | 'users' | 'medicoes' | 'fiscal') => {
      if (!entity) return context.role !== 'guest' && context.role !== 'client';
      const map: Record<string, AppPermission> = {
        orders: 'manage_orders',
        financial: 'manage_financial',
        vehicles: 'manage_vehicles',
        people: 'manage_people',
        users: 'manage_users',
        medicoes: 'manage_medicoes',
        fiscal: 'manage_fiscal'
      };
      return map[entity] ? context.hasPermission(map[entity]) : context.role !== 'guest';
    },
    canDelete: (entity?: 'orders' | 'financial' | 'vehicles' | 'people' | 'users' | 'medicoes') => {
      if (!entity) return context.role === 'admin';
      const map: Record<string, AppPermission> = {
        orders: 'delete_orders',
        financial: 'delete_financial',
        vehicles: 'delete_vehicles',
        people: 'delete_people',
        users: 'delete_user',
        medicoes: 'delete_medicoes'
      };
      return context.hasPermission(map[entity]);
    },
    canExport: () => context.hasPermission('export_reports')
  };
}

